const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1600&q=70`;
const PHOTOS = {
  finance: { photo: u("photo-1512403754473-27835f7b9984"), accent: "#1E3A8A" },
  consulting: { photo: u("photo-1758873269035-aae0e1fd3422"), accent: "#0F766E" },
  law: { photo: u("photo-1767972463877-b64ba4283cd0"), accent: "#7C2D12" },
  tech: { photo: u("photo-1631193816258-28b44b21e78b"), accent: "#4C1D95" },
  auto: { photo: u("photo-1567789884554-0b844b597180"), accent: "#B91C1C" },
  energy: { photo: u("photo-1466611653911-95081537e5b7"), accent: "#B45309" },
  luxury: { photo: u("photo-1596484552993-aec4311d3381"), accent: "#9D174D" },
  pharma: { photo: u("photo-1582560475093-ba66accbc424"), accent: "#047857" },
  other: { photo: u("photo-1554469384-e58fac16e23a"), accent: "#002147" },
};
const SECTOR_GROUP = {
  banking: "finance", finance: "finance", hedge_fund: "finance", prop_trading: "finance", insurance: "finance",
  consulting: "consulting", accounting: "consulting", law: "law",
  tech: "tech", telco: "tech", telecoms: "tech", "fashion-tech": "tech", "industrial-tech": "tech", semiconductors: "tech",
  automotive: "auto", "luxury-automotive": "auto", engineering: "auto", aerospace: "auto",
  energy: "energy", luxury: "luxury", retail: "luxury", "consumer-goods": "luxury", fmcg: "luxury",
  pharma: "pharma", "life-sciences": "pharma", healthcare: "pharma",
};
export const firmMeta = (f) => PHOTOS[SECTOR_GROUP[(f.sector || "").toLowerCase()] || "other"];
export const BAND_LABEL = { strong: "Strong pipeline", moderate: "Regular hires", emerging: "Emerging", trace: "Occasional" };
